interface PageMaxWidthProps {
    children: React.ReactNode;
    pageType: "form" | "dashboard";
}

const PageMaxWidth: React.FC<PageMaxWidthProps> = ({ children, pageType }) => {

    const getMaxWidth = () => {
        switch (pageType) {
            case "form":
                return "1280px";
            case "dashboard":
                return "1500px";
            default:
                return "10px";
        }
    };

    return (
        <div className="flex flex-col items-center">
            <div className="w-full" style={{ maxWidth: getMaxWidth() }}>
                {children}
            </div>
        </div>
    );
};

export default PageMaxWidth;
